import { defineComponent, onMounted, onUnmounted, PropType, reactive, watch } from 'vue'
import styles from './styles.module.scss'
import { ComponentActions, ComponentState } from '@/pages/chargermap/nsh5/localStores/component'
import { Store } from 'pinia'
import Spin from '../spin'
import html2canvas from 'html2canvas'
import { nioJsBridge } from '@nio-wad/universal-bridge-h5'
import { nextTick } from 'vue'
import { formatDate } from '@/utils/time'
import { currency } from '@/utils/currency'
import { isInApp } from '@/utils/env'

// 分享海报
export default defineComponent({
  name: 'poster-render-view',
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const indicator_suffix = (process.config as any).indicator_suffix
    if (!componentsConfig.share?.show) {
      return null
    }
    const state = reactive({
      shareMode: false,
      loading: true,
      canvasReady: false,
      shareBgImg:
        componentsConfig.share?.properties.share_bg_img ||
        'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/chargermap/share/share_bg_img.jpg',
      shareLeftTopImg:
        componentsConfig.share?.properties.share_left_top_img ||
        'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/chargermap/share/share_left_top_img.png',
      shareRightTopImg:
        componentsConfig.share?.properties.share_right_top_img ||
        'https://cdn-fx.nio.com/fx/pe-h5pages-fe/__cdn__/chargermap/share/share_right_top_img.png',
      shareGuideText: componentsConfig.share?.properties.save_img_desc || [
        '长按图片保存至手机相册',
        '分享给好友一起查看NIO资源布局',
      ],
      data: {
        // 海报数据
        totalSwapNum: 0,
        highSpeedSwapNum: 0,
        totalChargerNum: 0,
        totalChargerLineNum: 0,
        totalThirdChargerNum: 0,
      },
      statisticUpdateTime: '',
    })

    let base64Src = ''
    // 页面截屏并且显示在分享页面上
    const pageShare = () => {
      setTimeout(() => {
        state.loading = false
        let sharePage = document.getElementById('sharePage') as HTMLElement
        const options = {
          useCORS: true,
          allowTaint: true,
          scale: 2,
          width: Math.ceil(sharePage.offsetWidth * 2), // 解决android机型白边问题
          height: Math.ceil(sharePage.offsetHeight * 2), // 解决android机型白边问题
        }
        html2canvas(sharePage, options).then(function (canvasPage) {
          const imgPage = new Image()
          imgPage.src = canvasPage.toDataURL('image/png') //生成base64图片
          base64Src = imgPage.src
          document.getElementById('pageScreenShot')!.appendChild(imgPage)
          const dom = document.getElementById('pageScreenShot')!.firstChild! as HTMLElement
          dom.style.height = document.documentElement.clientHeight * 0.75 + 'px'
          dom.style.width =
            canvasPage.width *
              ((document.documentElement.clientHeight * 0.75) / canvasPage.height) +
            'px'
          state.canvasReady = true
          // 解决safari自带放大功能：阻止双指放大
          dom.addEventListener('gesturestart', function (event) {
            event.preventDefault()
          })
          // @ts-ignore
          canvasPage = null
          // @ts-ignore
          sharePage = null
        })
      }, 2000)
    }

    const openSharePoster = () => {
      // 获取海报数据
      getPosterData()
      const { y, MM, d } = formatDate(new Date().getTime()) // 获取当前时间
      state.statisticUpdateTime = `${y}.${MM}.${d}`
      state.shareMode = true
      nextTick(() => {
        pageShare()
      })
    }
    props.componentStore.bus.on('openSharePoster', openSharePoster)

    const getPosterData = () => {
      if (!props.componentStore?.summaryV2?.indicator_map) {
        // summaryV2不存在需要请求一遍接口
        props.componentStore.getSummaryV2()
      }
      console.log('======summary=====summaryV2=========================')
      console.log(props.componentStore.summaryV2)
      console.log('====================================')
    }

    const closeShare = () => {
      state.shareMode = false
      state.loading = true
      state.canvasReady = false
    }

    const savePhoto = () => {
      // base64Src && bridge.savePhotosAlbumBase([base64Src])
      console.log('调用 universal bridge 的保存图片功能')
      base64Src &&
        nioJsBridge.saveImage({
          data: {
            base64Images: [base64Src],
          },
        })
    }
    const isShow = (val: string) => {
      if (val) {
        if (isNaN(Number(val))) {
          return true
        } else if (Number(val) > 0) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }

    onUnmounted(() => {
      props.componentStore.bus.off('openSharePoster')
    })
    onMounted(() => {})
    return () => (
      <>
        {state.shareMode && (
          <div class={styles.shareContent}>
            {!state.loading ? (
              <>
                <ns-icon
                  name="back-r"
                  color="#fff"
                  size="28"
                  onClick={closeShare}
                  class={styles.back}
                />
                <div id="pageScreenShot" class={styles.pageScreenShot}></div>
                {state.canvasReady ? (
                  <>
                    {isInApp ? (
                      <div class={styles.downloadBtn} onClick={savePhoto}>
                        <p class="stopTextPress">保存至手机</p>
                      </div>
                    ) : (
                      <div class={styles.tips}>
                        {state.shareGuideText?.map((item: any) => (
                          <p class="stopTextPress">{item}</p>
                        ))}
                      </div>
                    )}
                  </>
                ) : null}
              </>
            ) : (
              <div class={styles.loading}>
                <Spin spinning={state.loading}></Spin>
              </div>
            )}
          </div>
        )}
        {/* 预加载的图片 */}
        {state.shareMode && (
          <div class={[styles.shareImg]} id="sharePage">
            <img crossorigin="anonymous" src={state.shareBgImg} alt="" />
            {/* 分享信息卡片 */}
            <div class={[styles.shareData]}>
              <div class={styles.dataCardCon}>
                <div class={styles.shareTopImgBox}>
                  <img src={state.shareLeftTopImg} alt="" />
                  <img src={state.shareRightTopImg} alt="" />
                </div>
                <div class={styles.data}>
                  <h2>{props.componentStore?.city?.name}充换电资源分布</h2>
                  <div class={styles.dataBox}>
                    {isShow(
                      props.componentStore?.summaryV2?.indicator_map[
                        `power_swap_charge_device_num_total${indicator_suffix}`
                      ]?.['indicator_item_map'][
                        `region_code:${props.componentStore?.city?.code || '000000'}`
                      ]?.['indicator_value']
                    ) ? (
                      <section>
                        <div>
                          <div>
                            <h6>蔚来能源充换电站总数</h6>
                            <strong class={styles.totalNum}>
                              {currency(
                                props.componentStore?.summaryV2?.indicator_map[
                                  `power_swap_charge_device_num_total${indicator_suffix}`
                                ]?.['indicator_item_map'][
                                  `region_code:${props.componentStore?.city?.code || '000000'}`
                                ]?.['indicator_value']
                              )}
                            </strong>
                            <span>座</span>
                          </div>
                        </div>
                      </section>
                    ) : null}
                    <section>
                      {componentsConfig?.data_default?.properties?.realtime_swap_num === 'on' ? (
                        <div class={styles.realtime}>
                          <h6>实时累计换电次数</h6>
                          <strong class={styles.totalNum}>
                            {currency(props.componentStore?.swapNum || '')}
                          </strong>
                        </div>
                      ) : null}
                      {isShow(
                        props.componentStore?.summaryV2?.indicator_map[
                          `swap_station_num_for_com${indicator_suffix}`
                        ]?.['indicator_item_map'][
                          `region_code:${props.componentStore?.city?.code || '000000'}`
                        ]?.['indicator_value']
                      ) ? (
                        <div class={styles.swap_station_number}>
                          <div>
                            <h6>蔚来能源换电站</h6>
                            <strong class={styles.totalNum}>
                              {currency(
                                props.componentStore?.summaryV2?.indicator_map[
                                  `swap_station_num_for_com${indicator_suffix}`
                                ]?.['indicator_item_map'][
                                  `region_code:${props.componentStore?.city?.code || '000000'}`
                                ]?.['indicator_value']
                              )}
                            </strong>
                            <span>座</span>
                          </div>
                          {/* 深度数据看板不需要展示高速公路换电站 */}
                          {isShow(
                            props.componentStore?.summaryV2?.indicator_map[
                              `intercity_swap_station_num${indicator_suffix}`
                            ]?.['indicator_item_map'][
                              `region_code:${props.componentStore?.city?.code || '000000'}`
                            ]?.['indicator_value']
                          ) && props.componentStore?.city?.code === '000000' ? (
                            <div>
                              <h6>其中高速公路换电站</h6>
                              <strong class={styles.totalNum}>
                                {currency(
                                  props.componentStore?.summaryV2?.indicator_map[
                                    `intercity_swap_station_num${indicator_suffix}`
                                  ]?.['indicator_item_map'][
                                    `region_code:${props.componentStore?.city?.code || '000000'}`
                                  ]?.['indicator_value']
                                )}
                              </strong>
                              <span>座</span>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </section>
                    <section>
                      {componentsConfig?.data_default?.properties?.realtime_swap_num === 'on' ? (
                        <div class={styles.realtime}>
                          <h6>实时累计充电次数</h6>
                          <strong class={styles.totalNum}>
                            {currency(props.componentStore?.chargeNum || '')}
                          </strong>
                        </div>
                      ) : null}
                      {isShow(
                        props.componentStore?.summaryV2?.indicator_map[
                          `power_charge_station_device_num_total${indicator_suffix}`
                        ]?.['indicator_item_map'][
                          `region_code:${props.componentStore?.city?.code || '000000'}`
                        ]?.['indicator_value']
                      ) ? (
                        <div>
                          <h6>蔚来能源充电站</h6>
                          <strong class={styles.totalNum}>
                            {currency(
                              props.componentStore?.summaryV2?.indicator_map[
                                `power_charge_station_device_num_total${indicator_suffix}`
                              ]?.['indicator_item_map'][
                                `region_code:${props.componentStore?.city?.code || '000000'}`
                              ]?.['indicator_value']
                            )}
                          </strong>
                          <span>座</span>

                          {isShow(
                            props.componentStore?.summaryV2?.indicator_map[
                              `power_charge_device_num_total${indicator_suffix}`
                            ]?.['indicator_item_map'][
                              `region_code:${props.componentStore?.city?.code || '000000'}`
                            ]?.['indicator_value']
                          ) ? (
                            <>
                              &nbsp;/&nbsp;
                              <strong class={styles.totalNum}>
                                {currency(
                                  props.componentStore?.summaryV2?.indicator_map[
                                    `power_charge_device_num_total${indicator_suffix}`
                                  ]?.['indicator_item_map'][
                                    `region_code:${props.componentStore?.city?.code || '000000'}`
                                  ]?.['indicator_value']
                                )}
                              </strong>
                              <span>根</span>
                            </>
                          ) : null}
                        </div>
                      ) : null}
                      <div class={styles.updateTime}>
                        <span>*截至{state.statisticUpdateTime}</span>
                      </div>
                      {/* {isShow(
                        props.componentStore?.summaryV2?.indicator_map[
                          `public_charger_num${indicator_suffix}`
                        ]?.['indicator_item_map'][
                          `region_code:${props.componentStore?.city?.code || '000000'}`
                        ]?.['indicator_value']
                      ) ? (
                        <div>
                          <h6>接入第三方充电桩</h6>
                          <strong>
                            {currency(
                              props.componentStore?.summaryV2?.indicator_map[
                                `public_charger_num${indicator_suffix}`
                              ]?.['indicator_item_map'][
                                `region_code:${props.componentStore?.city?.code || '000000'}`
                              ]?.['indicator_value']
                            )}
                          </strong>
                          <span>根</span>
                        </div>
                      ) : null} */}
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    )
  },
})
